import { useRef } from 'react'
import { styled } from '@mui/material'
import { StoryPeerType } from '@weblite/ts-action/story'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { useStoryRibbonByPeerIdAndPeerType } from '$logic/story/react-hooks'
import {
  PeerStoryViewer,
  StoryViewerActionsApi,
} from './peer-story-viewer/peer-story-viewer'
import { DesktopModeActionButtons } from './desktop-mode-action-buttons'

interface Props {
  peerId: string
  peerType: StoryPeerType
  isOpen: boolean
  onClose: () => void
  onCreateStory: (peerId: string, peerType: StoryPeerType) => void
}

export function SingleStory({
  peerId,
  peerType,
  isOpen,
  onClose,
  onCreateStory,
}: Props) {
  const storyRibbon = useStoryRibbonByPeerIdAndPeerType(peerId, peerType)

  const actionRef = useRef<StoryViewerActionsApi>(null)
  const isDesktop = useIsDesktopSize()
  if (!storyRibbon?.stories.length) {
    onClose()
    return null
  }
  return (
    <Root>
      <PeerStoryViewer
        onCreateStory={onCreateStory}
        onClose={onClose}
        ref={actionRef}
        storyRibbon={storyRibbon}
        isActive
        goToNextSlide={onClose}
        goToPrevSlide={onClose}
        isModalOpen={isOpen}
        sx={{
          maxWidth: isDesktop ? '400px' : undefined,
          maxHeight: isDesktop ? '900px' : undefined,
          borderRadius: isDesktop ? '12px' : undefined,
          overflow: 'hidden',
        }}
      />
      <DesktopModeActionButtons actionRef={actionRef} />
    </Root>
  )
}

const Root = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
`
